export enum VimeoVideoTranscodeStatus {
    Error = 'error',
    InProgress = 'in_progress',
    Complete = 'complete',
}

export enum VimeoUnavailablePlaceholderSize {
    Small = 'video-unavailable-placeholder-size-small',
    Large = 'video-unavailable-placeholder-size-large',
    SmallNoText = 'video-unavailable-placeholder-size-small-no-text',
    MediumNoDescription = 'video-unavailable-placeholder-size-medium-no-description',
}
